import React, {useState} from "react";
import {ButtonBase, Typography} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import DomesticPic from "../../image/domesticPic.jpg";
import OverseasPic from "../../image/overseasPic.jpg";
import i18n from "../../lib/appfuse-react/core/i18n";
import UserEvent from "../../lib/appfuse-react/core/UserEvent";
import Box from "../../lib/appfuse-react/component/Box";

const images = [
    {
        url: DomesticPic,
        title: 'Taiwan',
        value: 'domestic',
        content: "",
        subContent: ""
    },
    {
        url: OverseasPic,
        title: 'Outside Taiwan',
        value: 'overseas',
        content: "Please fill this form by farms or processing unit",
    },
];

const useStyles = (data, region) => makeStyles(theme => ({
    root: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        flexWrap: 'wrap',
        minWidth: 300,
        width: '100%',
        height: '100%',
        gap: '1em'
    },
    imageDomestic: {
        position: 'relative',
        minHeight: '32vh',
        maxHeight: '50vh',
        width: '45%',
        transition: 'ease-in-out .3s',
        transform: region === "domestic" && 'scale(1.01)',
        // [theme.breakpoints.down('xs')]: {
        //     width: '100% !important', // Overrides inline-style
        //     height: 100,
        // },
        '&:hover': {
            zIndex: 50,
            '& $imageBackdrop': {
                opacity: 0.15,
            },
            '& $imageMarked': {
                //opacity: 0,
                width: '100%',
            },
            '& $imageTitle': {
                // border: '4px solid currentColor',
            },
            '& $imageContent': {
                visibility: 'visible',
                opacity: 1,
            },
            '& $imageSubContent': {
                visibility: 'visible',
                opacity: 1,
            },
            transform: 'scale(1.01)'
        },
        '& $imageBackdrop': {
            opacity: region === "domestic" && 0.15,
        },
        '& $imageMarked': {
            width: region === "domestic" && '100%',
        },
        '& $imageContent': {
            visibility: region === "domestic" && 'visible',
            opacity: region === "domestic" && 1,
        },
        '& $imageSubContent': {
            visibility: region === "domestic" && 'visible',
            opacity: region === "domestic" && 1,
        },
        '& $imageTitle': {
            border: region === "domestic" && '3px solid currentColor',
        }

    },
    imageOverseas: {
        position: 'relative',
        minHeight: '32vh',
        maxHeight: '50vh',
        width: '45%',
        transition: 'ease-in-out, .3s',
        transform: region === "overseas" && 'scale(1.01)',
        // [theme.breakpoints.down('xs')]: {
        //     width: '100% !important', // Overrides inline-style
        //     height: 100,
        // },
        '&:hover': {
            zIndex: 50,
            '& $imageBackdrop': {
                opacity: 0.15,
            },
            '& $imageMarked': {
                //opacity: 0,
                width: '100%',
            },
            '& $imageTitle': {
                // border: '4px solid currentColor',
            },
            '& $imageContent': {
                visibility: 'visible',
                opacity: 1,
            },
            '& $imageSubContent': {
                visibility: 'visible',
                opacity: 1,
            },
            transform: 'scale(1.01)'
        },
        '& $imageBackdrop': {
            opacity: region === "overseas" && 0.15,
        },
        '& $imageMarked': {
            width: region === "overseas" && '100%',
        },
        '& $imageContent': {
            visibility: region === "overseas" && 'visible',
            opacity: region === "overseas" && 1,
        },
        '& $imageSubContent': {
            visibility: region === "overseas" && 'visible',
            opacity: region === "overseas" && 1,
        },
        '& $imageTitle': {
            border: region === "overseas" && '3px solid currentColor',
        }
    },
    imageButton: {
        position: 'absolute',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        // justifyContent: 'space-around',
        color: theme.palette.common.white,
    },
    imageSrc: {
        position: 'absolute',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        backgroundSize: 'cover',
        backgroundPosition: 'center 10%',
        borderRadius: '1.5rem'
    },
    imageBackdrop: {
        position: 'absolute',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        backgroundColor: theme.palette.common.black,
        opacity: 0.6,
        transition: theme.transitions.create('opacity'),
        borderRadius: '1.5rem'
    },
    imageTitle: {
        position: 'relative',
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        padding: `${theme.spacing(2)}px ${theme.spacing(4)}px ${theme.spacing(1) + 6}px`,
        borderTop: '0px',
        transition: theme.transitions.create('borderTop'),
        top: 70,
    },
    imageMarked: {
        height: 3,
        width: '20%',
        backgroundColor: theme.palette.common.white,
        position: 'absolute',
        bottom: -2,
        transition: theme.transitions.create('width'),
    },
    imageContent: {
        position: 'relative',
        visibility: 'hidden',
        opacity: 0,
        transition: 'visibility 0s, opacity 0.5s ease-in-out',
        transitionDelay: '0.2s',
        top: 90,
    },
    imageSubContent: {
        position: 'relative',
        visibility: 'hidden',
        transition: 'visibility 0s, opacity 0.5s ease-in-out',
        transitionDelay: '0.4s',
        opacity: 0,
        paddingTop: 20
    }
}));


function RegionButton(props) {
    const {region} = props;
    const [data, setData] = useState([]);
    const classes = useStyles(data, region)();

    const handleClick = index => event => {
        const value = event.currentTarget.value;
        const newData = [...data];
        newData[index] = value;
        setData(newData);
        props.onClick(new UserEvent({value: value}));
    }

    return (
        <div className={classes.root}>
            {images.map((image, index) => (
                <ButtonBase
                    focusRipple
                    value={image.value}
                    onClick={handleClick(index)}
                    key={index}
                    className={index === 0 ? classes.imageDomestic : classes.imageOverseas}
                    style={{borderRadius: '1.5rem'}}
                >
          <span
              className={classes.imageSrc}
              style={{
                  backgroundImage: `url(${image.url})`,
              }}
          />
                    <span className={classes.imageBackdrop}/>
                    <span className={classes.imageButton}>
            <Typography
                component="span"
                variant="h3"
                color="inherit"
                className={classes.imageTitle}
            >
              {i18n.translate(image.title)}
                <span className={classes.imageMarked}/>
            </Typography>
                          <span>
                    <Typography
                        variant="h6"
                        color="inherit"
                        className={classes.imageContent}
                    >
                        <Box display="flex" flexDirection="column">
                            <span>{i18n.translate(image.content)}</span>
                            <span className={classes.imageSubContent}>
                                {image.subContent}
                            </span>
                        </Box>
                    </Typography>
                    </span>
          </span>

                </ButtonBase>
            ))}
        </div>
    );
}


export default RegionButton;